import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography
} from '@mui/material';

import HomeIcon from '@mui/icons-material/Home';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import CampaignIcon from '@mui/icons-material/Campaign';
import EventIcon from '@mui/icons-material/Event';
import VerifiedIcon from '@mui/icons-material/Verified';
import PaymentIcon from '@mui/icons-material/Payment';
import QuizIcon from '@mui/icons-material/Quiz';
import LockResetIcon from '@mui/icons-material/LockReset';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { Send as SendIcon, Forum as ForumIcon, Comment as CommentIcon } from '@mui/icons-material';


import { useNavigate } from 'react-router-dom';

const navItems = [
  { label: 'Dashboard', icon: <HomeIcon sx={{ color: '#ff6600' }} />, path: '/dash' },
  { label: 'Courses', icon: <MenuBookIcon sx={{ color: '#ff6600'}} />, path: '/dashboard' },
  { label: 'Announcements', icon: <CampaignIcon sx={{ color: '#ff6600'}} />, path: '/announcements' },
  { label: 'Calendar', icon: <EventIcon sx={{ color: '#ff6600'}} />, path: '/calendar' },
  { label: 'Certificates', icon: <VerifiedIcon sx={{ color: '#ff6600'}} />, path: '/certificates' },
  { label: 'Payments', icon: <PaymentIcon sx={{ color: '#ff6600'}} />, path: '/payments' },
  { label: 'Exams', icon: <QuizIcon sx={{ color: '#ff6600'}} />, path: '/exams' },
  { label: 'Post Query', icon: <ChatBubbleIcon sx={{ color: '#ff6600'}} />, path: '/post-query' },
  { label: 'Profile', icon: <AccountCircleIcon sx={{ color: '#ff6600'}} />, path: '/profile' },
  { label: 'Community', icon: <ForumIcon sx={{ color: '#ff6600'}} />, path: '/video-community' },
 
];

const LeftNavbar = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="nav"
      sx={{
        width: 240,
        minHeight: '100vh',
        bgcolor: 'white',
        borderRadius: '0 1px 1px 0',
        boxShadow: '4px 0 12px rgba(0,0,0,0.1)',
        position: 'fixed',
        top: 0,
        display: { xs: 'none', lg: 'block' },
        p: 2,
      }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 2, fontWeight: 'bold', color: '#ff6600' }}
      >
        Dashboard
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <List>
        {navItems.map((item) => (
          <ListItem
            key={item.label}
            button
            onClick={() => navigate(item.path)}
            aria-label={`Go to ${item.label}`}
            sx={{
              borderRadius: 1,
              cursor: 'pointer',
              transition: 'all 0.25s ease',
              '&:hover': {
                backgroundColor: '#fff3e0',
                transform: 'scale(1.03)',
              },
              '&:hover .MuiListItemIcon-root, &:hover .MuiListItemText-primary': {
                color: '#ff6600',
              },
            }}
          >
            <ListItemIcon
              sx={{
                color: 'text.secondary',
                transition: 'color 0.3s ease',
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              sx={{
                transition: 'color 0.3s ease',
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default LeftNavbar;
